import { UserType } from "entities/users/types";
import { FC } from "react";
import PageHeading from "shared/components/PageHeading";
import TableWithPagination from "shared/components/TableWithPagination";
import PageSearchBar from "./components/PageSearchBar";
import { UsersPageProvider, useUsersPage } from "./context";
import { getUserColumns } from "./helpers";

const UsersContainer = () => (
  <UsersPageProvider>
    <UsersPage />
  </UsersPageProvider>
);

const UsersPage: FC = () => {
  const { loading, tableData, searchData } = useUsersPage();

  const columns = getUserColumns();

  return (
    <>
      <PageHeading />
      <PageSearchBar />
      <TableWithPagination<UserType>
        columns={columns}
        emptyStateMessage={
          !tableData.data.length && searchData.value
            ? "No Results Found"
            : "No users have interacted with the bot yet. This list will update as users join."
        }
        paginationMode="server"
        pageSizeOptions={[25, 50, 100]}
        loading={loading}
        {...tableData}
      />
    </>
  );
};
export default UsersContainer;
